import React, {FC, useEffect, useState} from "react";
import DataGrid, {Column, Pager, Paging, Scrolling, SearchPanel} from "devextreme-react/data-grid";
import axios from "axios";
import {useTypedSelector} from "../reducers";
import { useParams } from "react-router-dom";
import { LoadPanel } from "devextreme-react/load-panel";
import { useNavigate } from "react-router-dom";
import { handleError } from "../error/ErrorHandler";

type Props = {
    ctgId: number;
}

const BoardContent: FC<Props> = ({ctgId}) => {
    let { menuId } = useParams();
    const { site } = useTypedSelector(state => state.profile);

    const [ post, setPost ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { status, isAdmin, isLogin } = useTypedSelector(state => state.auth);
    const [ isCommonBoard, setIsCommonBoard ] = useState(false);
    const navigate = useNavigate();


    const getBoardPostByCategory = async() => {
        try {
            const res = await axios.get(`/api/board/post/by-category/${ctgId}`);
            if (res.data) setPost(res.data);
        } catch(err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    const getBoardyCategory = async() => {
        try {
            const res = await axios.get(`/api/board/ctg/one/${ctgId}`);
            console.log("########", ctgId, res.data);
            setIsCommonBoard(checkCommonBoard(res.data));
        } catch(err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    const onRowClick = (e: any) => {
        if (e.data && e.data.brdId) {
            setLoading(true);
            navigate(`/board/${menuId}/post/${Number(e.data.brdId)}`);
        }
    }

    const goToEdit = () => {
        navigate(`/board/${menuId}/edit`);
    }

    const checkCommonBoard = (category: any) => {
        return isLogin && category.usrWrtYn;
    }

    useEffect(() => {
        if(!ctgId || status === 'idle') return;
        getBoardPostByCategory();
        getBoardyCategory();
    }, [ctgId, status, menuId]);

    return (
        <div className={`board-content-wrapper ${site}`}>
            <div className={'board-content-body'}>
                { loading &&
                    <LoadPanel visible={true} />
                }
                { !loading &&
                    <DataGrid dataSource={post}
                            showColumnLines={false}
                            showRowLines={true}
                            onRowClick={onRowClick}>
                        <SearchPanel visible={true} />
                        <Column dataField={'brdId'} caption={'번호'} cssClass={'board-content-header text-center'} width={150} />
                        <Column dataField={'brdTitle'} caption={'제목'} cssClass={'board-content-header header-center'} />
                        <Column dataField={'usrNm'} caption={'작성자'} cssClass={'board-content-header text-center'} width={300} />
                        <Column dataField={'createdDtm'} caption={'작성일'} cssClass={'board-content-header text-center'} width={300} />
                        <Scrolling rowRenderingMode={'virtual'} />
                        <Paging defaultPageSize={5}>
                            <Pager visible={true} />
                        </Paging>
                    </DataGrid>
                }
                <div className={'board-content-button-wrapper'}>
                    {(isAdmin || isCommonBoard ) &&
                        <button onClick={goToEdit}>글쓰기</button>
                    }
                </div>
            </div>
        </div>
    );
}

export default BoardContent;
